import { useContext, useEffect, useRef } from "react";
import { ValidationContext } from "../contexts/ValidationContext";

export const useValidation = (func, inputs, options = {}) => {

    const {instantValidation, globalErrorMessage} = options;

    const validationContext = useContext(ValidationContext);
    const validationValuesRef = useRef(new Map());

    useEffect(() => {
        const validationValues = new Map(inputs
            .map(input => [input.name, input.ref.current !== null ? input.ref.current.value : input.value]));

        let changedInput = null;
        for (const [name, value] of validationValues) {
            if (validationValuesRef.current.get(name) !== value) {
                changedInput = inputs.find(input => input.name === name);
                break;
            }
        }
        if (changedInput !== null) {
            validationContext.setValidation(inputs, func, globalErrorMessage);
            if (instantValidation !== false) {
                validationContext.isValid(changedInput, false);
            }
        }
        validationValuesRef.current = validationValues;
    }, [JSON.stringify(inputs.map(i => i.value))]);
};
